import { useCallback, useState } from 'react'

// borrowed from ahooks
export const useUpdate = () => {
  const [, setState] = useState({})
  return useCallback(() => setState({}), [])
}
